import type { TrackedTranslation } from '@ps/web-core-intl';
import { phoneRMF } from '@ps/web-shared-validators';
import {
  formatIncompletePhoneNumber,
  getCountryCallingCode,
  getExampleNumber
} from 'libphonenumber-js';
import type { CountryCode } from 'libphonenumber-js';
import examples from 'libphonenumber-js/mobile/examples';
import type { ChangeEventHandler } from 'react';
import React from 'react';

import { DateInput } from '@swf/first';

import { TXTCLI_Number } from './PhoneNumberInput.messages.json';

interface Props {
  fieldName?: string;
  phoneFormatCountry?: string;
  callingCode?: string;
  label?: TrackedTranslation;
  placeholder?: string;
  autocompletePattern?: 'off' | 'cc-exp' | 'none';
  hideFormatInLabel?: boolean;
  hidePlaceholder?: boolean;
  value?: string;
  required?: boolean;
  autoFocus?: boolean;
  onChange?: ChangeEventHandler;
}
const PhoneNumberInput: React.FC<Props> = ({
  fieldName = 'phoneNumber',
  hidePlaceholder = true,
  phoneFormatCountry,
  callingCode,
  label = TXTCLI_Number,
  required,
  autoFocus,
  ...props
}) => {
  const prefix = getCountryCallingCode(phoneFormatCountry as CountryCode);

  const parsePhone = (value: string) => {
    if (!value) return '';
    const phoneNumber = getExampleNumber(phoneFormatCountry as CountryCode, examples);
    const examplePhone = phoneNumber?.formatInternational().replace(/[^0-9]/g, '');
    const phoneValue = prefix + value.replace(/[^0-9]/g, '');

    if (examplePhone && phoneValue.length > examplePhone.length) {
      value = value.slice(0, -1);
    }
    return value.replace(/[^0-9]/g, '');
  };

  const formatPhone = (value: string) => {
    if (!value) return '';
    if (value.length < 2) return value;

    try {
      const callingCode = '+' + prefix + ' ';
      const formatedPhone = formatIncompletePhoneNumber('+' + prefix + value);
      return formatedPhone.replace(callingCode, '');
    } catch {
      return value;
    }
  };

  return (
    <DateInput
      {...props}
      id={fieldName}
      hideFormatInLabel
      hidePlaceholder={hidePlaceholder}
      autoComplete="off"
      label={label}
      validators={[phoneRMF(prefix, required)]}
      parse={parsePhone}
      format={formatPhone}
      autoFocus={autoFocus}
    />
  );
};

export default PhoneNumberInput;
